import script from "./NftConstructorTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./NftConstructorTabs.vue?vue&type=script&setup=true&lang=js"

import "./NftConstructorTabs.vue?vue&type=style&index=0&id=65a271e8&lang=scss"

const __exports__ = script;

export default __exports__